import React from 'react'
import LabelParameters from '../LabelParameters'
import { useTranslation } from 'react-i18next';
import styles from '../CreateParameterPopup.module.css'
import { FaChevronDown } from "react-icons/fa";
const Amount = ({parameterData, handleChange,editingInput,setEditingInput,showSelectCurrencyPopup,setShowSelectCurrencyPopup}) => {
  const [t] = useTranslation("Contacts");

  return (
    <div>
        <LabelParameters value={parameterData.amount} text={'amount'} editingInput={editingInput} setEditingInput={setEditingInput}>
        <div className={styles.amountContainer}>
        <div className={styles.selectCurrencyBtn} onClick={() => setShowSelectCurrencyPopup(true)}>
                {parameterData.currency || 'Euro'}
                {` (${parameterData.code })`|| '(€)'}
                <FaChevronDown
              className={styles.chevronIcon}
              style={{
                transform: showSelectCurrencyPopup ? "rotate(180deg)" : "",
                transition: "transform 0.3s ease-in-out",
              }}
            />
            </div>
<input
          type="number"
          value={parameterData?.amount}
          name={'amount'}
          onChange={handleChange}
          placeholder='00.00'
        />
        </div>
</LabelParameters>
    </div>
  )
}

export default Amount